module.exports = __webpack_public_path__ + "img/ImGletscher.a8dfa85f.svg";